module.exports = __webpack_public_path__ + "img/pfeil-links.3376482a.svg";